import {
  GET_EVENTS, SET_EVENTS, SHOW_EVENTS_LOADER, HIDE_EVENTS_LOADER
} from "./actionTypes";

export const hideEventsLoader = () => ({
  type: HIDE_EVENTS_LOADER
})

export const showEventsLoader = () => ({
  type: SHOW_EVENTS_LOADER
})

export const getEvents = data => {
  return {
    type: GET_EVENTS,
    payload: data
  }
}

export const setEvents = data => ({
  type: SET_EVENTS,
  payload: data
})


